import { Link, useLocation } from "react-router-dom";
import { Home, Sparkles, ShoppingCart, ClipboardList, User } from "lucide-react";
import { useCartStore } from "../store/cartStore";

// Barre de navigation inférieure — MOBILE UNIQUEMENT (md:hidden).
// Réutilise le panier réel (useCartStore) : badge synchronisé. Aucun nouveau mécanisme.
const GREEN_DARK = "#004A36";
const ORANGE = "#FF5A1F";

const TABS = [
  { to: "/", label: "Accueil", Icon: Home, match: (p) => p === "/" },
  { to: "/tyluss", label: "TYLUSS", Icon: Sparkles, match: (p) => p.startsWith("/tyluss") },
  { to: "/panier", label: "Panier", Icon: ShoppingCart, match: (p) => p.startsWith("/panier"), badge: true },
  { to: "/commandes", label: "Commandes", Icon: ClipboardList, match: (p) => p.startsWith("/commandes") },
  { to: "/profil", label: "Profil", Icon: User, match: (p) => p.startsWith("/profil") },
];

export const BottomNav = () => {
  const loc = useLocation();
  const count = useCartStore((s) => s.getItemCount());

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50"
      style={{
        background: "#FFFFFF",
        borderTop: "1px solid #E9ECEA",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.04)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="bottom-nav"
    >
      <div className="flex items-stretch justify-around">
        {TABS.map(({ to, label, Icon, match, badge }) => {
          const active = match(loc.pathname);
          return (
            <Link
              key={to}
              to={to}
              data-testid={`bottomnav-${to.slice(1)}`}
              aria-current={active ? "page" : undefined}
              className="relative flex-1 flex flex-col items-center justify-center gap-0.5"
              style={{ minHeight: 56, color: active ? ORANGE : GREEN_DARK }}
            >
              {active && (
                <span
                  className="absolute top-0 left-1/2 -translate-x-1/2 h-[3px] w-8 rounded-full"
                  style={{ background: ORANGE }}
                />
              )}
              <div className="relative">
                <Icon size={22} strokeWidth={active ? 2.6 : 2} />
                {badge && count > 0 && (
                  <span
                    className="absolute -top-1.5 -right-2 text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1"
                    style={{ background: ORANGE, color: "#fff" }}
                    data-testid="bottomnav-cart-count"
                  >
                    {count}
                  </span>
                )}
              </div>
              <span className="text-[11px] font-semibold" style={{ lineHeight: 1 }}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
